import {
  isEmpty,
  isUnassignedUser,
  type SingleOrOptionalEntityIds,
  TANTALIM_ID,
  toTeamId,
  toUserId,
  uniqueEntities,
  type UserData,
  type UserId,
  type UserProfileData,
  type WithUserId,
} from '@terros/common'

export function getPlaceholderData(userId?: UserId): UserData | undefined {
  if (isEmpty(userId)) return
  const names = isUnassignedUser(userId)
    ? { firstName: 'Unassigned', lastName: 'User' }
    : { firstName: 'System', lastName: 'Bot' }
  return {
    userId,
    email: 'support@terros.com',
    ...names,
    avatarUrl: 'https://avatars.terros.com/U:system',
    avatarBlurhash: 'KVQvwRj[~qayfQay?bfQM{',
    companyId: TANTALIM_ID,
  }
}

export const toUniqueUsers = <T extends WithUserId>(users: T[]): T[] => {
  return uniqueEntities(users, toUserId)
}

export const getProfilePermissionIds = (
  user?: Pick<UserProfileData, 'companyId' | 'teams'>
): SingleOrOptionalEntityIds => {
  return [...(user?.teams?.directMemberOf.map(toTeamId) ?? []), user?.companyId]
}
